import React from "react";

export const TimerIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={props.style}
  >
    <path
      d="M10 0.999978C9.86749 0.998104 9.73593 1.02259 9.61296 1.072C9.48999 1.12141 9.37807 1.19477 9.2837 1.28782C9.18933 1.38086 9.11439 1.49173 9.06324 1.61399C9.0121 1.73625 8.98576 1.86745 8.98576 1.99998C8.98576 2.1325 9.0121 2.26371 9.06324 2.38596C9.11439 2.50822 9.18933 2.61909 9.2837 2.71214C9.37807 2.80518 9.48999 2.87854 9.61296 2.92796C9.73593 2.97737 9.86749 3.00185 10 2.99998H14C14.1325 3.00185 14.2641 2.97737 14.387 2.92796C14.51 2.87854 14.6219 2.80518 14.7163 2.71214C14.8107 2.61909 14.8856 2.50822 14.9368 2.38596C14.9879 2.26371 15.0142 2.1325 15.0142 1.99998C15.0142 1.86745 14.9879 1.73625 14.9368 1.61399C14.8856 1.49173 14.8107 1.38086 14.7163 1.28782C14.6219 1.19477 14.51 1.12141 14.387 1.072C14.2641 1.02259 14.1325 0.998104 14 0.999978H10ZM19.5195 3.98826C19.3737 3.98888 19.2298 4.02136 19.0979 4.08344C18.966 4.14552 18.8493 4.23569 18.7559 4.34763L17.457 5.85935C15.941 4.69771 14.0528 3.99998 12 3.99998C7.038 3.99998 3 8.03698 3 13C3 17.963 7.038 22 12 22C16.962 22 21 17.963 21 13C21 10.8108 20.2123 8.80206 18.9082 7.24021L20.2734 5.65232C20.4017 5.5078 20.4854 5.3292 20.5144 5.13812C20.5433 4.94704 20.5163 4.75166 20.4365 4.57562C20.3568 4.39959 20.2277 4.25043 20.065 4.14619C19.9022 4.04195 19.7128 3.9871 19.5195 3.98826ZM12 6.99998C12.552 6.99998 13 7.44798 13 7.99998V11.2773C13.595 11.6233 14 12.261 14 13C14 14.246 12.8594 15.2251 11.5664 14.9531C10.8414 14.8011 10.2375 14.2209 10.0625 13.5019C9.8315 12.5579 10.273 11.7003 11 11.2773V7.99998C11 7.44798 11.448 6.99998 12 6.99998Z"
      fill={props.fill || "#0E2125"}
    />
  </svg>
);

export const ProjectsIcon = (props) => (
  <svg
    style={{ marginLeft: "-1px" }}
    width="26"
    height="24"
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 4C4.448 4 4 4.447 4 5V21C4 21.553 4.448 22 5 22H9V4H5ZM11 4V12H24V5C24 4.447 23.552 4 23 4H11ZM11 14V22H17V14H11ZM19 14V22H23C23.552 22 24 21.553 24 21V14H19Z"
      fill={props.fill || "#0E2125"}
    />
  </svg>
);

export const CompletedIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3H14.816C14.403 1.837 13.304 1 12 1C10.696 1 9.597 1.837 9.184 3H5C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V5C21 3.895 20.105 3 19 3ZM8.707 10.293L11 12.586L15.293 8.293L16.707 9.707L11 15.414L7.293 11.707L8.707 10.293ZM12 3C12.552 3 13 3.448 13 4C13 4.552 12.552 5 12 5C11.448 5 11 4.552 11 4C11 3.448 11.448 3 12 3Z"
      fill={props.fill || "#0E2125"}
    />
  </svg>
);

export const SettingsIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4902 2C10.0112 2 9.60177 2.33859 9.50977 2.80859L9.17579 4.52344C8.35503 4.8338 7.59611 5.2674 6.92969 5.81445L5.28516 5.24805C4.83216 5.09205 4.33375 5.27936 4.09375 5.69336L2.58594 8.30664C2.34694 8.72164 2.43393 9.2485 2.79493 9.5625L4.11329 10.709C4.04472 11.1303 4 11.5593 4 12C4 12.4407 4.04472 12.8697 4.11329 13.291L2.79493 14.4375C2.43393 14.7515 2.34694 15.2784 2.58594 15.6934L4.09375 18.3066C4.33275 18.7216 4.83216 18.9089 5.28516 18.7539L6.92969 18.1875C7.59589 18.7342 8.3554 19.1663 9.17579 19.4766L9.50977 21.1914C9.60177 21.6614 10.0112 22 10.4902 22H13.5098C13.9888 22 14.3982 21.6614 14.4902 21.1914L14.8242 19.4766C15.645 19.1662 16.4039 18.7326 17.0703 18.1855L18.7148 18.752C19.1678 18.908 19.6663 18.7216 19.9063 18.3066L21.4141 15.6914C21.6531 15.2764 21.5661 14.7515 21.2051 14.4375L19.8867 13.291C19.9553 12.8697 20 12.4407 20 12C20 11.5593 19.9553 11.1303 19.8867 10.709L21.2051 9.5625C21.5661 9.2485 21.6531 8.72164 21.4141 8.30664L19.9063 5.69336C19.6673 5.27836 19.1678 5.09109 18.7148 5.24609L17.0703 5.8125C16.4041 5.26579 15.6446 4.83366 14.8242 4.52344L14.4902 2.80859C14.3982 2.33859 13.9888 2 13.5098 2H10.4902ZM12 8C14.209 8 16 9.791 16 12C16 14.209 14.209 16 12 16C9.791 16 8 14.209 8 12C8 9.791 9.791 8 12 8Z"
      fill={props.fill || "#0E2125"}
    />
  </svg>
);

export const MoonIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.80001 8.39998C6.14921 8.39998 4.00001 6.25078 4.00001 3.59998C4.00001 2.81998 4.19001 2.08598 4.52001 1.43518C2.59401 2.05918 1.20001 3.86598 1.20001 5.99998C1.20001 8.65078 3.34921 10.8 6.00001 10.8C7.87121 10.8 9.48801 9.72718 10.28 8.16478C9.81361 8.31598 9.31681 8.39998 8.80001 8.39998Z"
      fill={props.fill || "#0E2125"}
    />
  </svg>
);

export const CloseIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.70703 3.29297L3.29297 4.70703L10.5859 12L3.29297 19.293L4.70703 20.707L12 13.4141L19.293 20.707L20.707 19.293L13.4141 12L20.707 4.70703L19.293 3.29297L12 10.5859L4.70703 3.29297Z"
      fill={props.fill || "#0E2125"}
    />
  </svg>
);

export const PlusIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 3V11H3.5V13H11.5V21H13.5V13H21.5V11H13.5V3H11.5Z"
      fill={props.fill || "#0E212566"}
    />
  </svg>
);

export const BinIcon = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00366 2.08337L7.21199 2.87504H4.04533C3.60833 2.87504 3.25366 3.22971 3.25366 3.66671C3.25366 4.10371 3.60833 4.45837 4.04533 4.45837H15.1287C15.5657 4.45837 15.9203 4.10371 15.9203 3.66671C15.9203 3.22971 15.5657 2.87504 15.1287 2.87504H11.962L11.1703 2.08337H8.00366ZM4.04533 6.04171V16.3334C4.04533 17.2042 4.75783 17.9167 5.62866 17.9167H13.5453C14.4162 17.9167 15.1287 17.2042 15.1287 16.3334V6.04171H4.04533ZM7.5367 8.74451C7.73877 8.74451 7.94091 8.82092 8.09489 8.9749L9.58699 10.467L11.0791 8.9749C11.3871 8.66694 11.8875 8.66694 12.1955 8.9749C12.5034 9.28285 12.5034 9.78331 12.1955 10.0913L10.7034 11.5834L12.1955 13.0755C12.5034 13.3834 12.5034 13.8839 12.1955 14.1919C11.8875 14.4998 11.3871 14.4998 11.0791 14.1919L9.58699 12.6997L8.09489 14.1919C7.78693 14.4998 7.28647 14.4998 6.97852 14.1919C6.67056 13.8839 6.67056 13.3834 6.97852 13.0755L8.47062 11.5834L6.97852 10.0913C6.67056 9.78331 6.67056 9.28285 6.97852 8.9749C7.13249 8.82092 7.33463 8.74451 7.5367 8.74451Z"
      fill={props.fill || "#E4E4E4"}
    />
  </svg>
);

export const EditIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6777 2.08337C15.1048 2.08337 14.5318 2.30158 14.0944 2.73897L13.1667 3.66671L16.3333 6.83337L17.2611 5.90564C18.1351 5.03164 18.1351 3.61376 17.2611 2.73897C16.8237 2.30158 16.2507 2.08337 15.6777 2.08337ZM11.9792 4.85421L2.875 13.9584V17.125H6.04167L15.1458 8.02087L11.9792 4.85421Z"
      fill={props.fill || "#E4E4E4"}
    />
  </svg>
);

export const CheckIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.65 3.44995H5.34995C4.3002 3.44995 3.44995 4.3002 3.44995 5.34995V18.65C3.44995 19.6997 4.3002 20.5499 5.34995 20.5499H18.65C19.6997 20.5499 20.5499 19.6997 20.5499 18.65V5.34995C20.5499 4.3002 19.6997 3.44995 18.65 3.44995ZM10.7716 16.4716C10.4002 16.8431 9.7988 16.8431 9.4283 16.4716L6.29995 13.3433C5.92945 12.9727 5.92945 12.3705 6.29995 12C6.67045 11.6295 7.27275 11.6295 7.64325 12L10.1 14.4567L16.3567 8.19995C16.7272 7.82945 17.3295 7.82945 17.7 8.19995C18.0704 8.57045 18.0704 9.17275 17.7 9.54325L10.7716 16.4716Z"
      fill={props.fill || "#E4E4E4"}
    />
  </svg>
);

export const CaretLeft = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.61933 8L9.16667 5.45267C9.44267 5.17667 9.44267 4.72867 9.16667 4.45267C8.89067 4.17667 8.44267 4.17667 8.16667 4.45267L5.09067 7.52867C4.83 7.78933 4.83 8.21133 5.09067 8.47133L8.16667 11.5473C8.44267 11.8233 8.89067 11.8233 9.16667 11.5473C9.44267 11.2713 9.44267 10.8233 9.16667 10.5473L6.61933 8Z"
      fill={props.theme.text}
    />
  </svg>
);
//
export const TimerOptionIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.15001 2.02502V3.92502H14.85V2.02502H9.15001ZM12 4.87502C7.28611 4.87502 3.45001 8.71018 3.45001 13.425C3.45001 18.1399 7.28611 21.975 12 21.975C16.7139 21.975 20.55 18.1399 20.55 13.425C20.55 11.3424 19.7992 9.4323 18.5572 7.94768L19.9915 6.24065L18.5368 5.0179L17.1768 6.63586C15.7378 5.53571 13.9469 4.87502 12 4.87502ZM11.05 7.72503H12.95V11.7885C13.5153 12.1172 13.9 12.723 13.9 13.425C13.9 14.4748 13.0498 15.325 12 15.325C10.9503 15.325 10.1 14.4748 10.1 13.425C10.1 12.7239 10.4848 12.1182 11.05 11.7885V7.72503Z"
      fill={props.fill || "#E4E4E4"}
    />
  </svg>
);
